<template>
    <Dialog :dialog="dlg" xno-sub-title no-content-padding>

        <Datatable :dt="dt" class="full-height">
        </Datatable>

    </Dialog>
</template>



<script setup>
    import useDataTable from '@app/useDataTable'
    import Datatable from '@datatable/Datatable'
    import { tender_logs as api } from '@app/api'
    import { ref } from 'vue'
    import clsDialog from '@cls/clsDialog'
    import Dialog from '@shared/ui/dialogs/ActionDialog'



    var headers = [
        { text: "Tijdstip",                 value: "created_at",    type: 'datetime', isUtc:true,  visible: true},
        { text: "Type",                     value: "type"},
        { text: "Gebruiker",                value: "username", },
		{ text: "Geaddresseerde",           value: "recipients",    visible: true, fmt: (v,V,item) => v||"-"},
		{ text: "Referentie",               value: "id_link",    fmt: (v,V,item) => item.rep||item.id_link||"-"},
    ]

    var dt = useDataTable("dt_tender_history", "tender_history", api, headers, {
        itemName: {
            prefix: 'de',
            single: 'logregel',
            plural: 'logregels',
        }, parent: {
            id_tender: null // model.id
        },
        noAutoSearch: true, // Search not until the parent id is set.
        canArchive: false
    })


    class clsPModel {
        id = null;
        inv_number  = null;

        get subTitle() {
            if (this.isLoading || this.isDataLoading) {
                return 'Laden...';
            }
            return `Offerte ${this.tend_number}`;
        }
        async load(id, params) {
            params = params ||{}
            this.tend_number  = params.tend_number;            
            this.id = id;
            dt.setParent({id_tender: id}, true); // true: search
        }
    }

    let model = ref (new clsPModel());

    let dlg = ref(
        new clsDialog("tender_history", "Offertegeschiedenis", model, [], {            
            setKeyOnOpen: true,
            icon: 'log',
            maxWidth:'1200px', 
            showNote: false,
            showAttachment: false,
            save:false,
            cancel:'Sluit'
        } )).value;  //TODO

    window.dtl = dt;
</script>